<mat-sidenav-container [ngClass]="customClass">
  <div fxLayout="row">
    <div fxFlex="6" fxLayoutAlign="center">
      <div class="fixed-btn-left" fxLayout="column">
        <button mat-mini-fab color="white" (click)="openSettings($event)" *ngIf="shouldShowIcon('settings')">
          <mat-icon>settings</mat-icon>
        </button>
      </div>
    </div>
    <div fxFlex fxLayout="column" fxLayoutGap="5">
      <!-- Title -->
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <h1 style="margin: 0" mat-card-title>{{ titulo }}</h1>
        <ng-content select="[header]"></ng-content>
      </div>

      <!-- Table or Edit Form -->
      <div class="tabela-container" [ngClass]="{'edit-mode': mode === 'edit'}">
        <ng-content select="[table]"></ng-content>
      </div>

      <!-- Footer -->
      <ng-content select="[footer]"></ng-content>
    </div>

    <!-- FILTERS - Only show in list mode -->
    <div fxFlex="6" fxLayoutAlign="center" *ngIf="mode === 'list'">
      <div class="fixed-btn">

        <!-- Filters -->
        <div class="nav-item" *ngIf="shouldShowIcon('filters')">
          <button mat-mini-fab color="white" (click)="sidenav.toggle()"
            matTooltip="Filtros" matTooltipPosition="left">
            <mat-icon>filter_list</mat-icon>
          </button>
        </div>

        <!-- Partners -->
        <div class="nav-item" *ngIf="shouldShowIcon('partners') && !isMerchant">
          <button mat-mini-fab class="dashboard-button"
            (click)="navigateToCommissionDashboard()"
            [class.active]="isActiveRoute('/partner-dashboard')"
            matTooltip="Parceiros" matTooltipPosition="left">
            <img
              [src]="isActiveRoute('/partner-dashboard') ?
                    'assets/icons/dashboard-partner-blue.svg' :
                    'assets/icons/dashboard-partner.svg'"
              alt="Dashboard Partner"
              style="width: 26px; height: 26px;">
          </button>
        </div>

        <!-- Global -->
        <div class="nav-item" *ngIf="shouldShowIcon('global') && canShowDashboard() && !isMerchant && false">
          <button mat-mini-fab class="dashboard-button"
            (click)="navigateToDashboard()"
            [class.active]="isActiveRoute('/dashboard')"
            matTooltip="Global" matTooltipPosition="left">
            <mat-icon>insert_chart</mat-icon>
          </button>
        </div>

        <!-- Financial -->
        <div class="nav-item" *ngIf="shouldShowIcon('financial') && canShowFinancialDashboard() && !isMerchant">
          <button mat-mini-fab class="dashboard-button"
            (click)="navigateToAccountsDashboard()"
            [class.active]="isActiveRoute('/accounts-dashboard')"
            matTooltip="Financeiro" matTooltipPosition="left">
            <mat-icon>account_balance_wallet</mat-icon>
          </button>
        </div>

        <!-- Charges -->
        <div class="nav-item" *ngIf="shouldShowIcon('charges') && !isFinancial">
          <button mat-mini-fab class="dashboard-button"
            (click)="navigateToCharges()"
            [class.active]="isActiveRoute('/my-account')"
            matTooltip="Cobrança" matTooltipPosition="left">
            <mat-icon>payments</mat-icon>
          </button>
        </div>

        <!-- Home -->
        <div class="nav-item" *ngIf="shouldShowIcon('home')">
          <button mat-mini-fab color="primary" aria-label="Ir para Home"
            (click)="navigateToHome()" class="pulse-button"
            matTooltip="Home" matTooltipPosition="left">
            <mat-icon>home</mat-icon>
          </button>
        </div>

      </div>
    </div>
  </div>

  <!-- SIDEBAR - Only show in list mode -->
  <mat-sidenav #sidenav mode="over" position="end" style="min-width: 17%"
    *ngIf="mode === 'list'">
    <app-filter-crud-index
      [filterFields]="filterFields"
      [initialValues]="filterInitialValues"
      (onFilter)="submitAdvancedFilter($event)"
      (onResetFilter)="resetFilter()">
      <ng-content
        filter-header-buttons
        select="[filter-header-buttons]"></ng-content>
    </app-filter-crud-index>
  </mat-sidenav>
</mat-sidenav-container>
